import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const links = [
    { labelKey: 'nav.benefits', id: 'benefits' },
    { labelKey: 'nav.mission', id: 'emotional' },
    { labelKey: 'nav.contact', id: 'contact' },
  ];

  return (
    <footer className="bg-brand-black border-t border-gold/15 py-12 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo + tagline */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <img
              src="https://static.readdy.ai/image/1a62d479ea6bd5856073579187b5ee28/8348ef887df579edc93e4302d73f13a8.png"
              alt="AdoraLED Logo"
              className="h-8 w-auto object-contain"
            />
            <p className="font-body text-xs text-brand-white/40 text-center md:text-left">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Nav links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            {links.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                className="font-body text-xs text-brand-white/50 hover:text-gold transition-colors cursor-pointer whitespace-nowrap"
              >
                {t(link.labelKey)}
              </button>
            ))}
          </div>

          {/* Social */}
          <div className="flex items-center gap-4">
            {[
              { icon: 'ri-instagram-line', label: 'Instagram' },
              { icon: 'ri-facebook-circle-line', label: 'Facebook' },
              { icon: 'ri-youtube-line', label: 'YouTube' },
            ].map((s) => (
              <div
                key={s.label}
                className="w-8 h-8 flex items-center justify-center border border-brand-white/15 rounded-full hover:border-gold/50 hover:text-gold text-brand-white/50 transition-all cursor-pointer"
                aria-label={s.label}
              >
                <i className={`${s.icon} text-base`} />
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-brand-white/[0.06] text-center">
          <p className="font-body text-xs text-brand-white/30">
            {t('footer.copyright').replace('{year}', String(new Date().getFullYear()))}
          </p>
        </div>
      </div>
    </footer>
  );
}
